import React from "react";
import { Table, Typography, Empty, Tag } from "antd";
import { withRouter } from "react-router-dom";
import moment from "moment";
import VehicleName from "../../../VehicleName";

const { Text } = Typography;

const CustomerTable = (props) => {
  const { dataSource, spinner, pagination, history } = props;

  const handleRowClick = (record) => {
    const contacts = record?.partyName?.contacts || [];
    if (contacts.length > 0) {
      const primaryPhone = contacts[0].phone;
      history.push({
        pathname: `/autoadmin/service_feedback_call/${primaryPhone}`,
        state: {
          jobInvoiceId: record.id,
          status: props.status == "PENDING" ? "!FEEDBACK_COMPLETED" : "FEEDBACK_COMPLETED"
        },
      });
    }
  };

  const columns = [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "Customer Name",
      dataIndex: "partyName",
      key: "customerName",
      render: (partyName) => partyName?.name || "-",
    },
    {
      title: "Phone Numbers",
      dataIndex: "partyName",
      key: "phone",
      render: (partyName) => {
        const contacts = partyName?.contacts || [];
        return contacts.map((c) => c.phone).join(", ") || "-";
      },
    },
    {
      title: "Vehicle Model",
      dataIndex: "jobOrder",
      key: "vehicleModel",
      width: 260,
      render: (jobOrder) => (
        <VehicleName
          nameOnly
          value={jobOrder?.vehicle?.vehicle}
          fallback="-"
        />
      ),
    },

    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      render: (text) => moment(text).format("DD-MM-YYYY") || "-",
    },
    {
      title: "Branch Name",
      dataIndex: "branch",
      key: "branchName",
      render: (branch) => branch?.name || "-",
    },
  ];

  return (
    <Table
      loading={spinner}
      dataSource={dataSource}
      columns={columns}
      pagination={pagination}
      onRow={(record) => ({
        onClick: () => handleRowClick(record),
        style: { cursor: "pointer" },
      })}
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No Service Feedback Records Found"
          />
        ),
      }}
      rowKey="id"
    />
  );
};

export default withRouter(CustomerTable);
